var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"center"}},[_c('v-btn',{attrs:{"color":"primary","rounded":"","x-small":"","depressed":"","href":_vm.link}},[_c('v-icon',{attrs:{"x-small":""}},[_vm._v("mdi-twitter")]),_vm._v(" シェア ")],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }